module.exports = __webpack_public_path__ + "img/home-bg-red.93efed9e.jpg";